import { render, staticRenderFns } from "./FloatingActions.vue?vue&type=template&id=371a085e&scoped=true"
import script from "./FloatingActions.vue?vue&type=script&lang=js"
export * from "./FloatingActions.vue?vue&type=script&lang=js"
import style0 from "./FloatingActions.vue?vue&type=style&index=0&id=371a085e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371a085e",
  null
  
)

export default component.exports